(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cademe-adaptive-slideshow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function hidePosters() {
      document.querySelectorAll('.cademe-ss__video').forEach((video) => {
        const wrap = video.closest('.cademe-ss__video-wrap');
        const poster = wrap && wrap.querySelector('.cademe-ss__poster');
        if (!poster || poster.dataset.cademePosterInit === 'true') return;
        poster.dataset.cademePosterInit = 'true';
        const hide = () => poster.classList.add('is-hidden');
        video.addEventListener('canplay', hide, { once: true });
        video.addEventListener('playing', hide, { once: true });
        if (video.readyState >= 2) hide();
      });
    }
    hidePosters();
    document.addEventListener('shopify:section:load', hidePosters);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cademe-collection-split-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function hidePosters() {
      document.querySelectorAll('.cademe-sc__video').forEach((video) => {
        const wrap = video.closest('.cademe-sc__video-wrap');
        const poster = wrap && wrap.querySelector('.cademe-sc__poster');
        if (!poster || poster.dataset.cademeScPoster === 'true') return;
        poster.dataset.cademeScPoster = 'true';
        const hide = () => poster.classList.add('is-hidden');
        video.addEventListener('canplay', hide, { once: true });
        video.addEventListener('playing', hide, { once: true });
        if (video.readyState >= 2) hide();
      });
    }
    hidePosters();
    document.addEventListener('shopify:section:load', hidePosters);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cademe-image-with-text"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function hidePosters() {
      document.querySelectorAll('.cademe-iwt__video').forEach((video) => {
        const wrap = video.closest('.cademe-iwt__video-wrap');
        const poster = wrap && wrap.querySelector('.cademe-iwt__poster');
        if (!poster || poster.dataset.cademeIwtPoster === 'true') return;
        poster.dataset.cademeIwtPoster = 'true';
        const hide = () => poster.classList.add('is-hidden');
        video.addEventListener('canplay', hide, { once: true });
        video.addEventListener('playing', hide, { once: true });
        if (video.readyState >= 2) hide();
      });
    }
    hidePosters();
    document.addEventListener('shopify:section:load', hidePosters);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
